import React from 'react';
import PropTypes from 'prop-types';

/**
 * Footer component for SASAICHI website
 * Displays site navigation, social links, and company information
 */
const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-purple-900 via-violet-900 to-fuchsia-900 text-white relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-fuchsia-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* 会社情報 */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-violet-500 rounded-xl flex items-center justify-center shadow-lg">
                <i className="ri-sparkling-2-fill text-2xl text-white w-6 h-6 flex items-center justify-center"></i>
              </div>
              <span className="text-2xl font-black" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                SASAICHI
              </span>
            </div>
            <p className="text-purple-200 leading-relaxed mb-6 font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
              デジタルで紡ぐ、新しい物語。<br />
              ウェブコンテンツのトータルソリューション。
            </p>
            
          </div>

          {/* サービス */}
          <div>
            <h3 className="text-xl font-black mb-6" style={{ fontFamily: '"Shippori Mincho", serif' }}>
              サービス
            </h3>
            <ul className="space-y-3">
              {['企画', '制作', '管理・運営', '販売', 'プロデュース'].map((item, index) => (
                <li key={index}>
                  <a
                    href="#services"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('#services');
                    }}
                    className="text-purple-200 hover:text-white transition-colors duration-300 font-bold cursor-pointer"
                    style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 会社情報 */}
          <div>
            <h3 className="text-xl font-black mb-6" style={{ fontFamily: '"Shippori Mincho", serif' }}>
              会社情報
            </h3>
            <ul className="space-y-3">
              {[
                { label: '会社概要', href: '#about' },
                { label: 'アプローチ', href: '#approach' },
                { label: '導入実績', href: '#results' },
                { label: 'プライバシーポリシー', href: '/privacy' }
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      if (item.href.startsWith('#')) {
                        e.preventDefault();
                        scrollToSection(item.href);
                      }
                    }}
                    className="text-purple-200 hover:text-white transition-colors duration-300 font-bold cursor-pointer"
                    style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* お問い合わせ */}
          <div>
            <h3 className="text-xl font-black mb-6" style={{ fontFamily: '"Shippori Mincho", serif' }}>
              お問い合わせ
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-white/10 backdrop-blur-md rounded-lg flex items-center justify-center flex-shrink-0 border border-white/20">
                  <i className="ri-map-pin-line text-lg text-white w-5 h-5 flex items-center justify-center"></i>
                </div>
                <p className="text-purple-200 text-sm leading-relaxed font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                神奈川県横須賀市湘南鷹取六丁目１４番１３号
                </p>
              </div>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#contact');
                }}
                className="block px-8 py-3 bg-gradient-to-r from-fuchsia-500 to-violet-500 text-white text-center rounded-full font-black text-sm transition-all duration-300 hover:scale-105 shadow-lg border-2 border-white/20 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}
              >
                お問い合わせフォーム
              </a>
            </div>
          </div>
        </div>

        {/* コピーライト */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-purple-200 text-sm font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
              © 2024 合同会社SASAICHI. All rights reserved.
            </p>
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
